<template>
  <div>
    <transition name="modal" v-if="showModal">
      <div class="modal text-center">
        <div class="modal-content">
          <div class="payment-header">
            Proceed to Payment
          </div>
          <div class="modal-body">
            <div class="inputbox">
              <input type="text" :class="{ 'invalid-form': firstname.length > 0 && !nameIsValid }"
                placeholder="Full Name" v-model="firstname" value="">
            </div>
            <div class="inputbox">
              <input type="email" :class="{ 'invalid-form': email.length > 0 && !emailIsValid }" placeholder="Email"
                v-model="email" value="">
            </div>
            <div class="inputbox">
              <input type="text" :class="{ 'invalid-form': phone.length > 0 && !phoneIsValid }"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57" placeholder="Mobile Number"
                v-model="phone" value="">
            </div>
            <input type="button" v-bind:disabled="!formIsValid" class="pay-btn" name="Pay Now" @click="createOrder"
              value="Continue">
          </div>

          <div class="modal-footer">
            <button class="cancel-btn" @click="showModal = false">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </transition>
    <h2 class="my-5">
      <b>Complete payment</b>
    </h2>
    <table>
      <tr>
        <th>Filename</th>
        <th>Type</th>
        <th>Date</th>
        <th>Price</th>
      </tr>
      <tr v-for="item in OTUItems" :key="item.captureID" class="">
        <td>{{ truncate(item.filename) }}</td>
        <td>{{ item.type }}</td>
        <td>{{ item.timestamp }}</td>
        <td>
          <b>₹ {{ webArchivePrice }}</b>
        </td>
      </tr>
      <tr>
        <th class="pt-5">Sub Total</th>
        <td />
        <td />
        <td class="pt-5">
          <b>₹ {{ subTotal() }}</b>
        </td>
      </tr>
    </table>

    <table>
      <tr>
        <th>
          Offers
          <div v-if="couponCode" class="py-1 applied-code">
            <img width="13px" class="p-0 m-0" src="../assets/images/discount.svg" />
            <i>
              <b> {{ couponCode.toUpperCase() }} </b>
            </i>
            <button @click="removeCoupon">Remove</button>
          </div>
        </th>
        <td />
        <td />
        <td>
          <div v-if="discountPercent === 0" class="promo-ctr ml-auto col-md-4 mr-0 d-inline px-0">
            <input type="text" onkeypress="return event.charCode !==32" class="rounded" placeholder=" coupon code"
              spellcheck="false" v-model="couponField" />
            <button @click="couponCodeHandler" class="rounded">APPLY</button>
          </div>
          <div v-else class="price-green">
            <b> - ₹ {{ discount() }} </b>
          </div>
        </td>
      </tr>
      <tr>
        <th class="pt-5">Total</th>
        <td />
        <td />
        <td class="pt-5">
          <h3>
            <b>₹ {{ total() }} </b>
            <small class="text-muted">(INR)</small>
          </h3>
        </td>
      </tr>
    </table>
    <div v-if="!successMessage" class="mt-0 pt-5 text-right">
      <h5>Pay using : &nbsp;</h5>
      <br />
      <!--       <button class="btn rzp-btn" @click="razorPay">
        <img src="../assets/images/rzpay-long.png" />
      </button> -->
      <button class="btn payment-options-btn" @click="showModal = true">
        <img src="../assets/images/PayU.png" />
      </button>
    </div>
    <transition>
      <div v-if="errorMessage" class="danger-info p-3 my-5">
        <i class="fa fa-exclamation-triangle mr-3" />{{ errorMessage }}
      </div>
    </transition>
    <transition>
      <div v-if="successMessage" class="success-info p-3 my-5">
        <i class="fa fa-check-circle mr-3" />{{ successMessage }}
      </div>
    </transition>

    <div class="d-flex pt-5 steps-button">
      <button :disabled="OTUItems[0].isBackup === true" class="btn back-btn ml-0 mr-auto" @click="nextHandler(2)">
        <i class="fa fa-angle-left mr-2" /> Back
      </button>
      <button class="btn next-btn ml-auto mr-0" @click="nextHandler(4)" :disabled="!isStepComplete">
        Next <i class="fa fa-angle-right ml-2" />
      </button>
    </div>
    <a v-if="showReload === true" title="Start Over" @click="reload" id="startover-button"> <i
        class="fa fa-redo-alt"></i> </a>
  </div>
</template>
<script>
import cfg from "../config"
import truncate from "../functions/truncate"
export default {
  name: "Payment",
  props: {
    nextHandler: Function,
    OTUItems: Array,
  },
  data() {
    return {
      isStepComplete: false,
      showReload: false,
      errorMessage: null,
      successMessage: null,
      webArchivePrice: 4999,
      discountPercent: 0,
      couponCode: null,
      couponField: "",
      amount: 1,
      email: "",
      firstname: "",
      phone: "",
      showModal: false,
      emailIsValid: false,
      phoneIsValid: false,
      nameIsValid: false,
      paymentProcessURL: `${cfg.dataAPIURL}/payment/process-payu-payment`
    }
  },
  watch: {
    email(value) {
      this.emailIsValid = /^[^@]+@[^@]+\.[^@]+$/.test(value)
    },
    phone(value) {
      this.phoneIsValid = /^\d{10}$/.test(value)
    },
    firstname(value) {
      this.nameIsValid = /^[A-Za-z\s]+$/.test(value)
    }
  },
  computed: {
    formIsValid() {
      return this.emailIsValid && this.phoneIsValid && this.nameIsValid
    }
  },
  mounted() {
    this.isPaymentComplete()
  },
  methods: {
    async payU(hash) {
      //https://stackoverflow.com/questions/64543312/how-to-open-a-new-tab-with-a-post-request-from-a-component-in-angular
      const PAYU_MERCHANT_KEY = "qjomqh"
      this.firstname = this.firstname.trim()
      this.email = this.email.trim()
      this.phone = this.phone.trim()
      let params = {
        key: PAYU_MERCHANT_KEY,
        txnid: this.OTUItems[0].id,
        productinfo: "ExpertEvidence",
        amount: this.total().toString(),
        email: this.email,
        firstname: this.firstname,
        surl: this.paymentProcessURL,
        furl: this.paymentProcessURL,
        phone: this.phone,
        udf1: this.OTUItems[0].evType,
        hash: hash
      }
      var form = document.createElement("form")
      form.method = "POST"
      form.action = "https://secure.payu.in/_payment"
      for (var i in params) {
        if (params.hasOwnProperty(i)) {
          var input = document.createElement('input')
          input.type = 'hidden'
          input.name = i
          input.value = params[i]
          form.appendChild(input)
        }
      }
      document.body.appendChild(form)
      form.submit()
    },
    async createOrder() {
      if (this.isStepComplete) return
      try {
        this.OTUItems[0].couponCode = this.couponCode
        var now = new Date().getTime()
        this.OTUItems[0]["isBackup"] = true
        if (this.discountPercent == 100) {
          let data = {
            evType: this.OTUItems[0].evType,
            // email: this.email,
            // firstname: this.firstname,
            // phone: this.phone,
            // url: this.paymentProcessURL,
            couponCode: this.couponCode ? this.couponCode : ""
          }
          var appendOrderURL = `${cfg.dataAPIURL}/payment/appendorder/${this.OTUItems[0].id}`
          try {
            let response = await this.axios.post(appendOrderURL, data)
          } catch (error) {
            if (error.response.data === "order already completed") {
              this.isStepComplete = true
              this.successMessage = "Payment complete !"
              return
            }
            else throw new Error("Error Processing order")
          }
          this.isStepComplete = true
          this.successMessage = "Payment not required !"
          return
        }
        localStorage.setItem('backup_time', now)
        localStorage.setItem("OTUbackup", JSON.stringify(this.OTUItems))
        var payUOrderURL = `${cfg.dataAPIURL}/payment/payuorder/${this.OTUItems[0].id}`
        let payUdata = {
          evType: this.OTUItems[0].evType,
          paymentMode: "PayU",
          email: this.email,
          firstname: this.firstname,
          phone: this.phone,
          url: this.paymentProcessURL,
          couponCode: this.couponCode ? this.couponCode : ""
        }
        let response = await this.axios.post(payUOrderURL, payUdata)
        this.payU(response.data.hash)
      } catch (e) {
        console.log(e)
        this.errorMessage = "Unable to process payment request"
      }
    },
    async isPaymentComplete() {
      if (this.OTUItems[0].couponCode) {
        this.couponCode = this.OTUItems[0].couponCode
        this.applyCoupon(this.couponCode)
      }
      var evPath = this.OTUItems[0].evType === 2 ? "otu-signature" : "otu-capture"
      var url = `${cfg.dataAPIURL}/data/${evPath}/${this.OTUItems[0].id}`
      const response = await this.axios.get(url)
      if (response.data.payMentStatus === "success") {
        this.isStepComplete = true
        this.successMessage = "Payment complete !"
      }
      else {
        // Show the reload button if this is backup and payment not complete.
        if (this.OTUItems[0].isBackup === true)
          setTimeout(() => {
            this.showReload = true
          }, 1000)
      }
    },
    subTotal() {
      return Math.round(this.webArchivePrice * this.OTUItems.length)
    },
    discount() {
      return Math.round((this.discountPercent * this.subTotal()) / 100)
    },
    total() {
      return Math.round(this.subTotal() - this.discount())
    },
    couponCodeHandler() {
      this.applyCoupon(this.couponField.toUpperCase())
    },
    applyCoupon(couponField) {
      let coupons = { "BETA99": 99, "ONERUPEE": 99.98, "DEVZERO": 100 }
      if (couponField.toUpperCase().trim() in coupons) {
        this.couponCode = couponField.toUpperCase().trim()
        this.discountPercent = coupons[this.couponCode]
        if (this.couponCode === "DEVZERO")
          this.createOrder()
      }
      else this.discountPercent = 0
    },
    removeCoupon() {
      if (this.couponCode == "DEVZERO") {
        this.isStepComplete = false
        this.successMessage = null
      }
      this.couponCode = null
      this.discountPercent = 0
    },
    reload() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.showReload = false
    },
    truncate,
  },
}
</script>
<style scoped>
.payment-options-btn {
  background-color: #072551;
  height: 60px;
  width: 180px;
}

.payment-options-btn:hover {
  background-color: #1e4683;
}

.payment-options-btn img {
  width: 100px;
}

table {
  width: 100%;
  border: none;
  border-collapse: collapse;
  text-indent: initial;
  border-spacing: 2px;
  display: table;
  text-align: left;
}

td,
th {
  padding: 0.5rem;
}

td:last-child,
th:last-child {
  text-align: right;
  min-width: 100px;
}

.price-green {
  color: #06b477;
}

.promo-yellow {
  color: #f3db00;
}

.promo-ctr input {
  width: 130px;
  height: 28px;
  line-height: 28px;
  border: 1px solid var(--border-color);
  padding: 0 10px 0 10px;
  font-weight: 500;
  color: var(--font-primary);
  text-transform: uppercase;
}

.promo-ctr input:focus {
  outline: none;
}

.promo-ctr button {
  background: var(--primary-orange-yellow);
  color: #fff;
  border: none;
  height: 28px;
  line-height: 28px;
  outline: none;
  font-size: 12px;
  font-weight: 500;
}

.applied-code {
  height: 28px;
  line-height: 20px;
  align-items: center;
  display: inline;
  margin-left: 20px;
  border-radius: 5px;
  font-weight: 400;
}

.applied-code button {
  border: none;
  height: 22px;
  line-height: 20px;
  background: transparent;
  color: rgb(104, 104, 104);
  font-size: 11px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
}

@media only screen and (max-width: 600px) {

  td:nth-child(2),
  th:nth-child(2),
  td:nth-child(3),
  th:nth-child(3) {
    display: none;
  }

  .modal-content {
    width: 90% !important;
  }

  #startover-button {
    text-align: center;
    width: 35px !important;
    height: 35px !important;
    right: 10px !important;
  }

  #startover-button i {
    margin-top: 4px;
    font-size: 25px !important;
  }
}

@media only screen and (max-width : 420px) {}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(15px);
}

.modal-content {
  background-color: hsl(300, 40%, 20%);
  margin: 5% auto;
  border: 1px solid #888;
  width: 40%;
}

.modal-footer {
  border-bottom: 0px;
}

.payment-header {
  padding-top: 20px;
  font-size: 30px;
  color: aliceblue;
}

.modal-footer {
  border-top: 1px solid #494a4d;
  padding: 0;
}

.modal-body {
  padding-top: 2rem;
  padding-bottom: 1rem;
  box-sizing: border-box;
}

.modal-body .inputbox {
  position: relative;
}

.modal-body .inputbox input {
  text-align: center;
  color: aliceblue;
  width: 93%;
  padding: 0.625rem 10px;
  font-size: 1rem;
  letter-spacing: 0.062rem;
  margin-bottom: 1.875rem;
  border: 1px solid #ccc;
  background: transparent;
  border-radius: 4px;
  outline: none !important;
}

.pay-btn {
  width: 150px;
  background: var(--primary-green);
  border-radius: 5px;
  color: white;
  font-size: 19px;
  max-width: 27vw;
  height: 40px;
  margin-top: 20px;
}

.pay-btn:disabled {
  background: #1e7758;
}

.cancel-btn {
  background: none !important;
  border: none;
  color: #069;
  text-decoration: underline;
}

.invalid-form {
  border: 1px solid rgb(160, 59, 59) !important;
}

#startover-button {
  display: inline-block;
  background-color: var(--primary-orange-yellow);
  width: 50px;
  height: 50px;
  border-radius: 4px;
  position: fixed;
  bottom: 30px;
  right: 30px;
  transition: background-color .3s,
    opacity .5s, visibility .5s;
  z-index: 1000;
  text-align: center;
}

#startover-button i {
  font-size: 37px;
  color: #069;
  margin-top: 5px;
}

#startover-button:hover {
  cursor: pointer;
  background-color: darkorange;
}

#startover-button:active {
  background-color: #555;
}
</style>


// WEBPACK FOOTER //
// src/components/Payment.vue